import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { company } from "../data/site";
import { Reveal } from "./Reveal";

const CtaBanner = ({ title = "Ready to transform your outdoor space?" }) => (
  <section data-testid="cta-banner" className="bg-forest text-bone">
    <div className="container-fl py-20 md:py-28 flex flex-col md:flex-row md:items-center justify-between gap-10">
      <Reveal>
        <h2 className="font-serif text-4xl md:text-5xl text-bone max-w-2xl leading-tight">{title}</h2>
      </Reveal>
      <Reveal delay={0.1} className="flex flex-col sm:flex-row gap-4 shrink-0">
        <Link to="/contact" data-testid="cta-quote-btn" className="bg-bone text-forest px-8 py-4 font-medium tracking-wide hover:bg-clay hover:text-bone transition-colors">
          Get a Free Quote
        </Link>
        <a href={company.phoneHref} className="border border-bone/40 px-8 py-4 font-medium tracking-wide flex items-center justify-center gap-2 hover:bg-bone/10 transition-colors">
          <Phone size={18} strokeWidth={1.5} /> {company.phone}
        </a>
      </Reveal>
    </div>
  </section>
);

export default CtaBanner;
